import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StepModel, StepsDataStore } from 'src/app/models';
import { STEPS } from 'src/app/stubs/steps.stub.spec';
import Utils from 'src/app/utils/utils';

const STEPS_DATA_STORE = {
  1: undefined,
  2: undefined,
  3: undefined,
  4: undefined,
};

@Injectable({
  providedIn: 'root',
})
export class StepperService {
  steps$: BehaviorSubject<StepModel[]> = new BehaviorSubject<StepModel[]>(
    STEPS
  );
  currentStep$: BehaviorSubject<StepModel> = new BehaviorSubject<StepModel>(
    STEPS[0]
  );
  public stepsDataStore: StepsDataStore = STEPS_DATA_STORE;

  constructor() {
    this.stepsDataStore = Utils.loadFromLocalStorage('cacheSteps');
    this.currentStep$.next(this.steps$.value[0]);
  }

  get steps() {
    return this.steps$.getValue();
  }

  get currentStep() {
    return this.currentStep$.getValue();
  }

  setCurrentStep(step: StepModel): void {
    this.currentStep$.next(step);
  }

  getCurrentStep(): Observable<StepModel> {
    return this.currentStep$.asObservable();
  }

  getSteps(): Observable<StepModel[]> {
    return this.steps$.asObservable();
  }

  prevStep(): void {
    if (this.isFirstStep()) {
      return;
    }
    const step = this.steps.find(
      (step) => step.stepIndex === this.currentStep.stepIndex - 1
    );
    this.setCurrentStep(step!);
  }

  moveToNextStep(data: any = {}): void {
    const index = this.updateStepData(data);

    let nextStep: StepModel =
      this.steps.find((step) => step.stepIndex === index + 1) ||
      this.steps[index];
    nextStep.isComplete = true;
    nextStep = { ...nextStep, data: data };
    if (index < this.steps$.value.length) {
      this.setCurrentStep(nextStep);
    }
  }

  updateStepData(data: any): number {
    const index = this.currentStep$.value.stepIndex;
    this.currentStep.data = data;
    this.stepsDataStore[index] = this.currentStep;
    // Utils.saveToLocalStorage('cacheSteps', JSON.stringify(this.stepsDataStore));
    return index;
  }

  updateStepDataByIndex(stepIndex: number, data: any): void {
    const step = this.stepsDataStore[stepIndex];
    if (step) {
      this.stepsDataStore[stepIndex] = {
        ...step,
        data,
        isComplete: false,
        stepIndex: step.stepIndex,
        name: step.name,
      };
    }
  }

  goToFirstStep() {
    this.setCurrentStep(STEPS[0]);
  }

  isLastStep(): boolean {
    return this.currentStep.stepIndex === this.steps$.value.length;
  }

  isFirstStep(): boolean {
    return this.currentStep$.value.stepIndex === this.steps$.value[0].stepIndex;
  }

  cleanDataStored(): void {
    this.stepsDataStore = { ...STEPS_DATA_STORE };
  }
}
